module.exports = __webpack_public_path__ + "static/media/Privacy Policy And Hipaa Business Associate Agreement.59bf0678.pdf";